import { module as ModuleJS } from "modujs";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

// Snapshot tailwind config with babel-plugin-preval
const tailwindScreens = preval`
    const resolveConfig = require('tailwindcss/resolveConfig');
    const tailwindConfig = require('./../../../tailwind.config.js');

    const fullConfig = resolveConfig(tailwindConfig)
    module.exports = fullConfig.theme.screens;
`;

export default class extends ModuleJS {
    constructor(m) {
        super(m);

        this.deg = parseInt(this.getData('deg')) || 90;
    }

    init() {
        gsap.fromTo(
            this.el,
            {
                rotate: 0,
            },
            {
                scrollTrigger: {
                    trigger: this.el,
                    scrub: 0.5,
                },
                roundProps: {
                    rotate: 1
                },
                rotate: this.deg,
                ease: "none",
            }
        );

        ScrollTrigger.create({
            trigger: this.el,
            start: 'top bottom',
            end :'bottom top',
            toggleClass: 'u-in-view'
        });
    }

    bindEvents(el) {}

    update(newContainer) {}

    destroy(oldContainer) {}
}
